<template>
  <v-row class="asc-breadcrumbs--parent" no-gutters>
    <v-col>
      <v-breadcrumbs :items="breadcrumbItems">
        <template #item="{ item }">
          <v-breadcrumbs-item
            v-if="item.html"
            :to="item.to"
            exact
            v-html="item.html"
          ></v-breadcrumbs-item>
          <v-breadcrumbs-item
            v-else
            :to="item.to"
            exact
            :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    breadcrumbItems() {
      return this.items.map(breadcrumbItem => {
        !breadcrumbItem.to
          ? (breadcrumbItem.disabled = true)
          : (breadcrumbItem.disabled = false)
        return breadcrumbItem
      })
    },
  },
}
</script>

<style lang="scss">
.asc-breadcrumbs--parent {
  padding: 12px 0 0 8px;

  div.asc-breadcrumbs--home-icon-div {
    padding-top: 13px;
    padding-left: 5px;
    padding-right: 8px;

    a,
    a:hover {
      text-decoration: none;
    }
  }

  ul.v-breadcrumbs {
    padding: 8px 12px !important;

    .v-breadcrumbs__item {
      color: $ascentia-orange !important;

      &:hover {
        opacity: 0.9;
      }
    }

    .v-breadcrumbs__item--disabled {
      color: $gray-700 !important;
    }

    .v-breadcrumbs__divider {
      padding: 4px;
    }
  }
}
</style>
